import classNames from 'classnames';
import {observer} from 'mobx-react';
import React, {ChangeEventHandler} from 'react';
import {InputAutoWidth} from '../../../../../../lib/components';
import {ReactNodeGenerator} from '../../../../../../lib/helpers';
import {X9ContentStateStore} from '../../../common/X9ContentStateStore';
import {GapFillingModel, GapFillingParagraph, GapItem, TextItem} from '../../models';
import {isMatch} from '../kbt-utils';
import {KbtGapFillingStore} from '../KbtGapFillingStore';
import {ItemPosition, positionToItemId} from '../models';

interface Props {
  id: number,
  model: GapFillingModel,
  store: X9ContentStateStore
}

function renderTextItem(item: TextItem, index: number) {
  return (<span key={index} className="text">{item.content}</span>);
}

function renderGapItem(item: GapItem,
                       store: KbtGapFillingStore,
                       paragraph: number,
                       index: number): React.ReactNode {
  const position: ItemPosition = {paragraph: paragraph, index: index};
  const itemId = positionToItemId(position);

  const state = store.gapStates[itemId];

  const isValid = isMatch(state.filledWith, item.value);
  const isCheckedValid = state.checked && isValid;
  const isCheckedInvalid = state.checked && !isValid;
  const isDisabled = isCheckedValid;


  let classname = classNames('gap', {
    valid: isCheckedValid,
    invalid: isCheckedInvalid
  });

  const changeHandler: ChangeEventHandler<HTMLInputElement> = (change) =>  {
    store.onInputChange(itemId, change);
  }
  
  return (
    <InputAutoWidth key={index}
                    font="normal 400 14px Roboto"
                    className={classname}
                    placeholder={item.placeholder}
                    value={state.filledWith}
                    onChange={changeHandler}
                    disabled={isDisabled}/>);
}

function* paragraphItems(store: KbtGapFillingStore,
                         paragraphIndex: number,
                         paragraph: GapFillingParagraph): ReactNodeGenerator {
  for (let index = 0; index < paragraph.items.length; index++) {
    let item = paragraph.items[index];
    if (item.type === 'text')
      yield renderTextItem(item, index);
    if (item.type === 'gap')
      yield renderGapItem(item, store, paragraphIndex, index);
  }
}

function* renderer(store: KbtGapFillingStore): ReactNodeGenerator {
  const paragraphs = store.model.paragraphs;

  for (let index = 0; index < paragraphs.length; index++) {
    let paragraph = paragraphs[index];

    yield (
      <div key={index} className="gap-filling-paragraph">
        {
          Array.from(paragraphItems(store, index, paragraph))
        }
      </div>);
  }
}

@observer
export class StudentKbtGapFilling extends React.Component<Props> {
  readonly store: KbtGapFillingStore;

  constructor(props: Readonly<Props>) {
    super(props);
    this.store = new KbtGapFillingStore(props.id, props.model, props.store);
  }

  render() {
    return (
      <>
        <div className="row">
          <div className="col">
            {Array.from(renderer(this.store))}
          </div>
        </div>
        <div className="row justify-content-end">
          <div className="col-auto">
            <button type="button" className="btn btn-primary"
                    onClick={this.store.check}>
              Check
            </button>
          </div>
        </div>
      </>
    );
  }
}
